import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_product_list = (page, per_page, keyword) => {
  return api.post(`${ApiEndpointConstants.GETPRODUCTLIST}`, {
    page,
    per_page,
    keyword, 
  });
};
